import { Response } from '@candu-ai/first-mate/api';

export const IMAGE_API = '/api/first-mate/image';

export type ImageRequest = {
  prompt: string;
  n: number;
  model: 'dall-e-3' | 'dall-e-2';
  style: 'vivid' | 'natural';
  response_format: 'b64_json' | 'url';
};

interface ImageUrl {
  url: string;
}

export type ImageResponse = Response<{
  res: {
    data: ImageUrl[];
  };
}>;
